export default __webpack_public_path__ + "static/media/inner-logo.72dc951f.svg";